
export default {
  props: {
    regionSelected: {
      type: Object,
      default: false
    },
    regions: {
      type: Object,
      default: false
    }
  },
  data: () => ({
    modalOpen: false,
    localSelectedRegion: null,
    localRegions: null,
    toolTipVisible: true
  }),
  watch: {
    selectedRegion: function (newVal) {
      this.localSelectedRegion = newVal
    },
    regions: function (newVal) {
      this.localSelectedRegion = newVal
    }
  },
  created() {
    this.localSelectedRegion = this.regionSelected
    this.localRegions = this.regions
    if (!this.regionSelected) {
      this.modalOpen = true
    }
  },
  methods: {
    isSelected (region) {
      if(this.localSelectedRegion) {
        return this.localSelectedRegion.instance === region.instance
      }
    },
    /**
     * Get the browser location and store it in our store
     * If fail, shows a toaster to the user
     * @param {Boolean} continuously
     */
    selectRegion (region) {
      this.localSelectedRegion = region
      this.$emit('regionSelected', region)
      this.closeModal()
    },
    openModal () {
      this.modalOpen = !this.modalOpen
      this.toolTipVisible = this.menuOpen
    },
    closeModal () {
      this.modalOpen = !this.modalOpen
    }
  },
  computed: {
    showTooltip () {
      return this.menuOpen
    },
  }
}
